/**
 * Stockfish scores, shared by the analysis (api/src/schaak/analyse.ts) and the
 * review of a mistake on the phone, so the bar on screen and the rule that
 * called the move a mistake are one formula.
 */
/** Lichess's winning chance in [-1, 1]. */
export function winChance(e) {
    if (e.mate != null)
        return e.mate > 0 ? 1 : -1;
    const cp = Math.max(-1000, Math.min(1000, e.cp ?? 0));
    return 2 / (1 + Math.exp(-0.00368208 * cp)) - 1;
}
/** "+0,4", "−2,3", "M3", "−M2", "mat" — Dutch decimal comma, a real minus sign. */
export function formatEval(e) {
    if (e.mate != null) {
        if (e.mate === 0)
            return 'mat';
        return e.mate > 0 ? `M${e.mate}` : `−M${-e.mate}`;
    }
    const p = (e.cp ?? 0) / 100;
    const s = Math.abs(p).toFixed(1).replace('.', ',');
    return p > 0.04 ? `+${s}` : p < -0.04 ? `−${s}` : '0,0';
}
//# sourceMappingURL=eval.js.map